<template>
    <v-row>
        <v-col v-for="detail in team" :key="detail.id" cols="12" class="">
            <v-card flat align="center" class="card dt-border">
                <v-row align="center" >
                    <v-col md="8" class="card__column">
                        <img
                        class="card__column__img"
                        width="40"
                        height="40"
                        :src="detail.profile.profilepicture" alt="image"
                        />
                        <router-link class="black--text" :to="$route.path+'/'+detail.id">{{`${detail.profile.firstname} ${detail.profile.lastname}`}}</router-link>
                        <v-icon v-if="detail.isactive == true" color="green" class="ml-5">
                            mdi-checkbox-marked-circle-outline
                        </v-icon>
                        <v-icon v-if="detail.isactive == false" color="red" class="ml-5">
                            mdi-close-circle-outline
                        </v-icon>
                    </v-col>
                    <v-col md="2">
                        <!-- <v-btn title="Edit" icon depressed dark color="#3C3C3C" style="float:right">
                            <v-icon size="20">
                                mdi-application-edit
                            </v-icon>
                        </v-btn> -->
                    </v-col>
                    <v-col md="2">
                        <v-btn dark @click="removeFromTeam(detail)" color="#F36F2E" depressed style="float:right;font-size:12px">
                            Remove
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import {  TeamService } from "@/services";
import app from '@/main';
export default {
    data: () => ({
    success: false,
    loading:false,
  }),
  props: {
    id: {
        type: String
    },
    team: {
      type: Array,
    },
  },
  methods: {
    async removeFromTeam(detail){
        this.loading = true;
        console.log("this is anothe file", detail)
        console.log("this is crazy here", this.id)
        TeamService.removeFromTeam({
          admin: detail.id,
          department : this.id
        }).then(()=>{
            this.team.forEach((e,i)=>{
                if(e.id == detail.id){
                    this.team.splice(i,1);
                }
            });
          this.success = true;
          this.loading = false;
          app.$store.dispatch('toast', {
          message: 'Admin removed successfully',
          variant: 'success'
        })
          setTimeout(()=>{ this.success = false;},100);
          this.$emit("add-member");
      
        })
      }
  },
  mounted() {
      
  },
};
</script>

<style lang="scss" scoped>
@import './styles.scss'
</style>
